"use client";
import React from "react";
import AllMember from "../../components/about/MemberComp";

const member = [
  {
    img: "/images/about/m1.jpeg",
    name: "Muhammad Hassan",
  },
  {
    img: "/images/about/m2.jpeg",
    name: "Rashid Ali",
  },
  {
    img: "/images/about/m3.jpeg",
    name: "M Ahsan",
  },
  {
    img: "/images/about/m4.jpeg",
    name: "Zohaib",
  },
  {
    img: "/images/about/m1.jpeg",
    name: "Muhammad Hassan",
  },
  {
    img: "/images/about/m2.jpeg",
    name: "Rashid Ali",
  },
  {
    img: "/images/about/m3.jpeg",
    name: "M Ahsan",
  },
  {
    img: "/images/about/m4.jpeg",
    name: "Zohaib",
  },
  {
    img: "/images/about/m1.jpeg",
    name: "Muhammad Hassan",
  },
  {
    img: "/images/about/m2.jpeg",
    name: "Rashid Ali",
  },
  {
    img: "/images/about/m3.jpeg",
    name: "M Ahsan",
  },
  {
    img: "/images/about/m4.jpeg",
    name: "Zohaib",
  },
];

export default function MemberCTR() {
  return <AllMember data={member} />;
}
